module.exports = __webpack_public_path__ + "static/media/satisfaction1.a14428a1.svg";